<template>
    <div class="about">
        <h3 v-if="emptyPdf">There is no documents to display. Please create one first.</h3>
        <template v-else>
            <h1>Output</h1>
            <embed
                    id="pdf"
                    :src="src"
                    type="application/pdf"
                    width="75%"
                    height="1000px"
            />
        </template>
    </div>
</template>

<script>
    import {Vue, Component} from 'vue-property-decorator';

    @Component
    export default class Output extends Vue {
        emptyPdf = true
        src = null
        async mounted() {
            const outputBlob = this.$store.state.outputBlob
            if (Object.keys(outputBlob).length === 0 && outputBlob.constructor === Object ) {
                this.emptyPdf = true
            } else {
                this.emptyPdf = false
                this.src = URL.createObjectURL(outputBlob)
            }

        }
    }
</script>
